import React, { useEffect, useState } from 'react';
import { CustomDate } from './logic';
import FontAwesomeCheckSquare from './components/FontAwesomeCheckSquare';

import './Timer.scss';

export const Timer = ({widgetData}) => {
  const { isShowCountdown } = widgetData;

  const [estimatedShipping, setEstimatedShipping] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);

  if(isShowCountdown === 'true'){
    useEffect(() => {
      const timer = new CustomDate({...widgetData});
      setEstimatedShipping(timer.getEstimatedDate());
      setTimeLeft(timer.getTimeLeft());
      const interval = setInterval(() => {
        setTimeLeft(timer.getTimeLeft());
      }, 1000 * 30);

      return function cleanUp() {
        clearInterval(interval);
      };
    }, []);
  }
  else {
    useEffect(() => {
      const timer = new CustomDate({...widgetData});
      setEstimatedShipping(timer.getEstimatedDate());
      setTimeLeft(timer.getTimeLeft());
    }, []);
  }


  if(!estimatedShipping){
    return null;
  }

  if(isShowCountdown === 'false'){
    return (
        <div className="Timer">
          <FontAwesomeCheckSquare />
          <span>Get it by <strong>{estimatedShipping}</strong></span>
        </div>
    )
  }

  return (
      <div className="Timer">
        <span>Want it <strong>{estimatedShipping}?</strong> Order it in the next <strong className="text-green">{timeLeft}</strong></span>
      </div>
  )
}

export default Timer;
